import { Injectable } from '@angular/core';

import { filterSportsEmitLast } from '@frontend/sports/host-app/sports-product/feature/utils';
import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../base/store/state';
import { RewardTokensActions } from '../actions';
import { RewardTokensDataService } from './reward-tokens-data.service';

@Injectable()
export class RewardTokensBootstrapService {
    constructor(
        private rewardTokensData: RewardTokensDataService,
        private store: Store<IBetslipRootState>,
    ) {}

    init(): void {
        this.rewardTokensData.tokens$.pipe(filterSportsEmitLast()).subscribe((tokens) => {
            this.store.dispatch(RewardTokensActions.setTokens({ payload: tokens }));
        });
    }
}
